import { snakeCaseToWords } from '@ui/utils/utils'

const ISSUE_CATEGORY_LABELS: Record<TIssueCategory, string> = {
    configuration_changes: 'Configuration Changes',
    software_updates: 'Software Updates',
    network_exposures: 'Network Exposures',
    security_controls: 'Security Controls',
    email_threats: 'Mailbox Issue',
    user_account_compromise: 'User Account Compromise',
}

export const getIssueCategoryLabel = (category?: TIssueCategory): string => {
    if (!category) {
        return 'Issue'
    }
    return ISSUE_CATEGORY_LABELS[category] ?? snakeCaseToWords(category)
}
